import React from 'react';

export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-teal-700 to-teal-800 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          <div className="lg:col-span-2">
            <img 
              src="https://static.readdy.ai/image/96c584895f690011767589183eb2ca42/de1eb034a8050bb932df7f8474b52559.png" 
              alt="SecureHome Logo" 
              className="h-12 w-auto mb-6 brightness-0 invert"
            />
            <p className="text-teal-100 mb-6 leading-relaxed">
              Protecting homes and families with advanced security technology and 24/7 professional monitoring since 2010.
            </p>
            <div className="flex gap-4">
              <a 
                href="https://instagram.com/redeyesystemsinc" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer"
                aria-label="Follow us on Instagram"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Products</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('products')} className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                  Alarm Systems
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('products')} className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                  IP Cameras
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('products')} className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                  Sensors
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('products')} className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                  Smart Doorbells
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Services</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('services')} className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                  24/7 Monitoring
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('installation')} className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                  Installation
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                  Smart Home Integration
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                  Customer Support
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Company</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                  About Us
                </a>
              </li>
              <li>
                <a href="#" className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                  Careers
                </a>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                  Contact
                </button>
              </li>
              <li>
                <a href="#" className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                  FAQ
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-teal-100 text-sm">
              © 2025 SecureHome. All rights reserved.
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-teal-100 hover:text-white text-sm transition-colors cursor-pointer">
                Privacy Policy
              </a>
              <a href="#" className="text-teal-100 hover:text-white text-sm transition-colors cursor-pointer">
                Terms of Service
              </a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-teal-100 hover:text-white text-sm transition-colors cursor-pointer">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
